module.exports = __webpack_public_path__ + "img/tit3@2x.7ac6c7ac.png";